/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useCellSelection = require("./useCellSelection");
var _default = {
  name: 'cell-selection',
  hook: _useCellSelection.useCellSelection,
  defaultProps: function defaultProps() {
    return {};
  }
};
exports.default = _default;